/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-03 15:19:07
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-03 15:19:35
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SlugInput/tool.ts
 */
const generateDefaultSlug = (slug?) => {
  return {
    urlSlug: slug || '',
    slugValid: true,
  };
};
export { generateDefaultSlug };
